import { LOGIN_FORM_UPDATE } from '../../actions/loginForm';
import { LOG_IN } from '../../actions/auth';

const initialState = {
  email: "",
  password: "",
  posting: false,
  errors: []
}

const loginForm = (state = initialState, action) => {
  switch(action.type) {
    case LOGIN_FORM_UPDATE:
      return { ...state, ...action.payload };
    case `${LOG_IN}_PENDING`:
      return { ...state, posting: true };
    case `${LOG_IN}_FULFILLED`:
      return initialState;
    case `${LOG_IN}_REJECTED`:
      return { ...state, posting: false, errors: ["Incorrect e-mail/password"] };
    default:
      return state;
  }
}

export default loginForm;



// WEBPACK FOOTER //
// ./src/reducers/ui/loginForm.js